import path from "path";
import { Global } from "@/global";
import { Filesystem } from "@/util/filesystem";
import { onMount } from "solid-js";
import { createStore, produce, unwrap } from "solid-js/store";
import { createSimpleContext } from "../../context/helper";
import { appendFile, writeFile } from "fs/promises";
const MAX_HISTORY_ENTRIES = 50;
export const {
  use: usePromptHistory,
  provider: PromptHistoryProvider
} = createSimpleContext({
  name: "PromptHistory",
  init: () => {
    const historyPath = path.join(Global.Path.state, "prompt-history.jsonl");
    onMount(async () => {
      const text = await Filesystem.readText(historyPath).catch(() => "");
      const lines = text.split("\n").filter(Boolean).map(line => {
        try {
          return JSON.parse(line);
        } catch {
          return null;
        }
      }).filter(line => line !== null).slice(-MAX_HISTORY_ENTRIES);
      setStore("history", lines);

      // Rewrite file with only valid entries to self-heal corruption
      if (lines.length > 0) {
        const content = lines.map(line => JSON.stringify(line)).join("\n") + "\n";
        writeFile(historyPath, content).catch(() => {});
      }
    });
    const [store, setStore] = createStore({
      index: 0,
      history: []
    });
    return {
      move(direction, input) {
        if (!store.history.length) return undefined;
        const current = store.history.at(store.index);
        if (!current) return undefined;
        if (current.input !== input && input.length) return;
        setStore(produce(draft => {
          const next = store.index + direction;
          if (Math.abs(next) > store.history.length) return;
          if (next > 0) return;
          draft.index = next;
        }));
        if (store.index === 0) return {
          input: "",
          parts: []
        };
        return store.history.at(store.index);
      },
      append(item) {
        const entry = structuredClone(unwrap(item));
        let trimmed = false;
        setStore(produce(draft => {
          draft.history.push(entry);
          if (draft.history.length > MAX_HISTORY_ENTRIES) {
            draft.history = draft.history.slice(-MAX_HISTORY_ENTRIES);
            trimmed = true;
          }
          draft.index = 0;
        }));
        if (trimmed) {
          const content = store.history.map(line => JSON.stringify(line)).join("\n") + "\n";
          writeFile(historyPath, content).catch(() => {});
          return;
        }
        appendFile(historyPath, JSON.stringify(entry) + "\n").catch(() => {});
      }
    };
  }
});